import axios from "axios";
import {
  FETCH_PRODUCTGROUPS,
  FETCH_PRODUCTGROUPS_BY_SUPPLIER,
  FETCH_PRODUCTGROUPS_FARMER,
  FETCH__SUPPLIERS,
} from "./actionTypes";

export const getAssortiment = async (
  identifyInfo,
  currentSupplier,
  loginSuccesful,
  setState
) => {
  //MAKE DYNAMIC FOR PUBLIC VS LOGGED IN
  let requestBody = {};
  if (currentSupplier == "All") {
    requestBody = {
      marketplace: identifyInfo.marketplace,
      key: identifyInfo.key,
    };
  } else {
    requestBody = {
      marketplace: identifyInfo.marketplace,
      key: identifyInfo.key,
      farmer: currentSupplier,
    };
  }
  if (!loginSuccesful) {
    await axios.post("/public_assortment", requestBody).then((response) => {
      setState(response.data.data.groups);
    });
  } else {
    await axios.post("/farmers_assortment", requestBody).then((response) => {
      setState(response.data.data.groups);
    });
  }
};

export const farmerProducts = async (
  identifyInfo,
  currentSupplier,
  loginSuccesful,
  setState
) => {
  //MAKE DYNAMIC FOR PUBLIC VS LOGGED IN

  let requestBody = {};

  if (!loginSuccesful) {
    requestBody = {
      marketplace: identifyInfo.marketplace,
      key: identifyInfo.key,
      farmer: currentSupplier,
    };

    await axios
      .post("/public_farmer_assortment", requestBody)
      .then((response) => {
        setState(response.data.data.products);
      });
  } else {
    requestBody = {
      farmer: currentSupplier,
    };
    await axios.post("/farmer_assortment", requestBody).then((response) => {
      setState(response.data.data.products);
    });
  }
};

export const fetchProductsByGroup = async (
  currentLocation,
  userId,
  groupId,
  setState
) => {
  await axios
    .post("/productsbygroup", {
      location: currentLocation,
      user_id: userId,
      group_id: groupId,
    })
    .then((response) => {
      setState(response.data.data.products);
    });
};

export const fetchProductsByGroupFarmer = async (
  loginSuccesful,
  identifyInfo,
  groupId,
  setState
) => {
  let url = loginSuccesful
    ? "/farmers_main_group_products_per_subgroup"
    : "/public_farmers_main_group_products_per_subgroup";
  await axios
    .post(url, {
      key: identifyInfo.key,
      marketplace: identifyInfo.marketplace,
      main_group_id: groupId,
    })
    .then((response) => {
      setState(response.data.data.groups);
    });
};

export const fetchProductGroups = (currentLocation, userId) => (dispatch) => {
  const requestData = {
    location: currentLocation,
    user_id: userId,
  };

  return axios
    .post("/productgroups", requestData)
    .then((response) => {
      const assortimentData = response.data.data.slice; // debug voor te veel producten. We moeten pagina's inbrengen.

      return dispatch({
        type: FETCH_PRODUCTGROUPS,
        payload: assortimentData,
      });
    })
    .catch((err) => {
      console.log(
        "[Assortiment.actions.js] fetchProductGroups|| Could not fetch productgroups. Try again later."
      );
    });
};

export const fetchProductGroupsFarmer =
  (loginSuccesful, identifyInfo) => (dispatch) => {
    console.log("YOOOO");
    let requestData = {
      key: identifyInfo.key,
      marketplace: identifyInfo.marketplace,
    };
    let url = loginSuccesful ? "/farmers_groups" : "/public_farmers_groups";
    console.dir(url);
    return axios
      .post(url, requestData)
      .then((response) => {
        return dispatch({
          type: FETCH_PRODUCTGROUPS_FARMER,
          payload: response.data.data.groups,
        });
      })
      .catch((err) => {
        console.log(
          "[Assortiment.actions.js] fetchProductGroupsFarmer|| Could not fetch fetchProductGroupsFarmer. Try again later."
        );
      });
  };

export const fetchProductGroupsBySupplier =
  (currentLocation, userId, supplierId) => (dispatch) => {
    const requestData = {
      location: currentLocation,
      user_id: userId,
      supplier: supplierId,
    };

    return axios
      .post("/productgroupsbysupplier", requestData)
      .then((response) => {
        const assortimentData = response.data.data.groups; //TODO: check met api

        return dispatch({
          type: FETCH_PRODUCTGROUPS_BY_SUPPLIER,
          payload: assortimentData,
        });
      })
      .catch((err) => {
        console.log(
          "[Assortiment.actions.js] fetchproductsbysupplier|| Could not productgroups by supplier. Try again later."
        );
      });
  };

export const fetchSuppliers = (currentLocation, userId) => (dispatch) => {
  const requestData = {
    location: currentLocation,
    user_id: userId,
  };

  return axios
    .post("/suppliers", requestData)
    .then((response) => {
      // debug voor te veel producten. We moeten pagina's inbrengen.
      return dispatch({
        type: FETCH__SUPPLIERS,
        payload: response.data.data.suppliers,
      });
    })
    .catch((err) => {
      console.log(
        "[Assortiment.actions.js] fetchSuppliers|| Could not fetch suppliers of this location. Try again later."
      );
    });
};

export const addBarcodeToProduct = (row_data_id, barcode) => (dispatch) => {
  const requestData = {
    id: row_data_id,
    ean: barcode,
  };

  return axios
    .post("/linkbarcode", requestData)
    .then((response) => {
      alert(response.data.data.message);
      window.location.href =
        window.location.origin + window.location.pathname + "#/addbarcode";
    })
    .catch((err) => {
      console.log(
        "[Assortiment.actions.js] addBarcodeToProduct|| Could add barcode to this product. Try again later."
      );
    });
};

export const getAllSupplierInfo = async (
  loginSuccesful,
  identifyInfo,
  setState
) => {
  if (loginSuccesful) {
    await axios
      .post("/farmers", {
        marketplace: identifyInfo.marketplace,
        key: identifyInfo.key,
      })
      .then((response) => {
        setState(response.data.data.suppliers);
      });
  } else {
    await axios
      .post("/public_suppliers", {
        marketplace: identifyInfo.marketplace,
        key: identifyInfo.key,
      })
      .then((response) => {
        setState(response.data.data.suppliers);
      });
  }
};

export const obtainProductInfo = (
  event,
  identifyInfo,
  loginSuccesful,
  currentLocation,
  changeUsedSearchTerm,
  setProducts
) => {
  if (loginSuccesful) {
    const requestData = {
      string: event,
      location: currentLocation.id,
    };
    axios
      .post("/searchproducts", requestData)
      .then((response) => {
        // if (response.data.data.products.length === 0) {
        // 	//setProductsFoundByQuery(false);
        // 	//changeUsedSearchTerm(false);
        // } else {
        //setProductsFoundByQuery(true);
        changeUsedSearchTerm(true);
        setProducts(response.data.data.products);
        //}
      })
      .catch((err) => {
        alert("Er is iets mis gegaan, scan opnieuw.");
        console.log(
          "[getProductName.actions.js] getProductInfo || Could not obtain product information of this barcode. Try again later."
        );
      });
  } else {
    const requestData = {
      string: event,
      marketplace: identifyInfo.marketplace,
      key: identifyInfo.key,
    };
    axios
      .post("/public_search", requestData)
      .then((response) => {
        if (response.data.data.products === 0) {
          changeUsedSearchTerm(false);
          //setProductsFoundByQuery(false);
        } else {
          //setProductsFoundByQuery(true);
          changeUsedSearchTerm(true);
          //props.changeProducts(response.data)
          setProducts(response.data.data.products);
        }
      })
      .catch((err) => {
        alert("Er is iets mis gegaan, scan opnieuw.");
        console.log(
          "[getProductName.actions.js] getProductInfo || Could not obtain product information of this barcode. Try again later."
        );
      });
  }
};
